import { Box, BoxProps } from '@chakra-ui/layout'
import React from 'react'

import { LayoutProps } from './interfaces'
import { Col, Container, Row } from './styles'

export const Layout: React.FC<BoxProps & LayoutProps> = ({
    children,
    type,
    gutter,
    layout,
    full,
    ...props
}) => {
    const TYPE = {
        container: Container,
        row: Row,
        col: Col
    }
    const Element = TYPE[type]
    return (
        <Element
            as={Box}
            gutter={gutter}
            layout={layout}
            full={full}
            {...props}
        >
            {children}
        </Element>
    )
}
